import React from 'react';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';   // 👈 Important

const CustomerInfoCard = ({ 
  name, 
  email, 
  phoneNumber, 
  numberOfItems, 
  billingAddress 
}) => {
  return (
    <div className=" bg-white border-round-sm w-full">

      <div className="grid">

        {/* Left Column */}
        <div className="col-12 md:col-6">

          <div className="mb-4 item-details-dialog-body">
            <span className="block item-details-dialog-header mb-2 item-details-dialog-header">Name</span>
            <div className="text-sm">{name}</div>
          </div>

          <div className="mb-4 item-details-dialog-body">
            <span className="block item-details-dialog-header mb-2 ">Phone Number</span>
            <div className="text-sm">{phoneNumber}</div>
          </div>

          <div className="mb-4 item-details-dialog-body">
            <span className="block item-details-dialog-header mb-2">No. of Items</span>
            <div className="text-sm">{numberOfItems}</div>
          </div>

        </div>

        {/* Right Column */}
        <div className="col-12 md:col-6">

          <div className="mb-4 item-details-dialog-body">
            <span className="block item-details-dialog-header mb-2">Email Address</span>
            <div className="text-sm">
              {email}
            </div>
          </div>

          <div className="mb-4 item-details-dialog-body">
            <span className="block item-details-dialog-header mb-2">Billing Address</span>
            <div className="text-sm white-space-pre-line">
              {billingAddress}
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default CustomerInfoCard;